import { Box, Container, Typography } from "@mui/material";
import WhyElement, {
  WhyElementProps,
} from "../../../components/WhyElement/WhyElement";
import img1 from "../../../img/why-icon-1.png";
import img2 from "../../../img/why-icon-2.png";
import img3 from "../../../img/why-icon-3.png";

const WhyElements: Array<WhyElementProps> = [
  {
    title: "Get your collection from the rack to the web",
    description:
      "Easily upload photos of your shirts, add details like match-worn status, signatures and more. Organize by club or league, track your investments and share your collection with friends. Your shirts' stories, all in one place.",
    imageUrl: img1,
    imgZoomLevel: 1,
  },
  {
    title: "Determine the value of your collection",
    description:
      "Determine the value of your collection with ease. Our advanced value calculator, powered by AI, accurately predicts the current value of your shirts by analyzing historical sales data and player/team info.",
    imageUrl: img2,
    imgZoomLevel: 1.1,
  },
  {
    title: "Get your shirts authenticated online",
    description:
      "Connect with expert collectors and have your shirts authenticated peer-to-peer. Whether it's a match-worn piece or a rare edition, fellow enthusiasts will help you verify the authenticity of your collection.",
    imageUrl: img3,
    imgZoomLevel: 0.9,
  },
];

const Why = () => {
  return (
    <Container
      maxWidth={false}
      sx={{
        padding: { xs: "2.5rem 0rem", sm: "4rem 0rem" },
        backgroundColor: "#f9f9f9",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: "4",
            width: "100%",
          }}
        >
          <Typography
            variant="sectionTitle"
            sx={{
              textAlign: { xs: "center", md: "left" },
              lineHeight: "1.2",
              fontStyle: "italic",
            }}
          >
            Join the community of footballshirt collectors!
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "top",
              flexWrap: "wrap",
            }}
          >
            {WhyElements.map((item, index) => (
              <Box
                key={`whySectionItem_${index}`}
                sx={{
                  width: {
                    xs: "100%",
                    md: "calc(33.33% - 40px)",
                    lg: "calc(33.33% - 60px)",
                  },
                }}
              >
                <WhyElement
                  title={item.title}
                  description={item.description}
                  imageUrl={item.imageUrl}
                  imgZoomLevel={item.imgZoomLevel}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

export default Why;
